var map = {
	"./brand-01.svg": 79457,
	"./brand-02.svg": 90770,
	"./brand-03.svg": 94083,
	"./brand-04.svg": 96156,
	"./brand-05.svg": 24701,
	"./brand-06.svg": 62078,
	"./brand-07.svg": 98479,
	"./brand-08.svg": 66504,
	"./brand-09.svg": 78873,
	"./brand-10.svg": 73171,
	"./brand-11.svg": 85794,
	"./brand-12.svg": 42897,
	"./brand-13.svg": 28512,
	"./brand-14.svg": 45983
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14640;